var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['text-xl', _vm.value !== true && _vm.value !== false ? 'fas fa-circle text-gray-200' : _vm.value === true ? 'fas fa-check text-green-400' : 'fas fa-times text-red-400']})}
var staticRenderFns = []

export { render, staticRenderFns }